import React, { useContext, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { formatNumberWithCommas } from 'helper';
import PropTypes from 'prop-types';
import { ModalContext } from 'App';
import { getJson } from 'session';
import { Acl } from 'modules/common/components/Acl';
import _ from 'lodash';
import * as actions from '../action';
import * as c from '../constant';
import ReasonModal from '../../property-assessment/modals/ReasonModal';
import ViewTaxableReasonModal from '../../property-assessment/modals/ViewTaxableReasonModal';


function PropertyAssessmentTab({
  applicationId,
  getPropertyAssessmentLogs,
  historyPropertyAssessmentList,
  permissions,
  isLoadingHistoryPropertyAssessment,
  historyTotalAppraisedValue,
  historyTotalAssessmentLevel,
  historyTotalAssessedValue,
  historyTotalDepreciation,
  historyTotalMarketValue,
  historyTotalArea,
  historyInfo
}) {

  useEffect(() => {
    if (_.isEmpty(historyInfo)) return;
    getPropertyAssessmentLogs(historyInfo.id)
  }, []);

  useEffect(() => {
    if (_.isEmpty(historyInfo)) return;
    getPropertyAssessmentLogs(historyInfo.id)

  }, [historyInfo]);

  const setModal = useContext(ModalContext);

  const handleChange = (e, id, data) => {

    setModal({
      isOpen: true,
      content: (
        <ReasonModal
          id={data.id}
          applicationId={id}
          updateList={data.attributes}
        />
      ),
      title: 'Add Exemption Reason',
      modalSize: 'modal-md',
    });
  };

  const handleView = (dataInfo) => (e) => {
    e.preventDefault();
    setModal({
      title: 'View Exemption Reason',
      isOpen: true,
      content: <ViewTaxableReasonModal taxableReason={dataInfo} />,
      modalSize: 'modal-lg',
    });
  };

  return (
    <div className="card p-0 mr-2">
      {isLoadingHistoryPropertyAssessment ? (
        <div className="loading">
          <div className="spinner text-center">
            <span className="fas fa-1x fa-spin fa-spinner" />
          </div>
        </div>
      ) : (
        <>
          <div className="table-div">
            <div className="table-assessment row my-3 mx-2">
              <table className="table table-borderless">
                <thead className="table-header">
                  <tr className="cms-bg-color-primary-light cms-text-primary">
                    <td className="fixed-col font-weight-bold cms-bg-color-primary-light cms-text-primary">Actual Use</td>
                    <td className="font-weight-bold cms-bg-color-primary-light cms-text-primary">Area</td>
                    {Acl(permissions, ['E2E RPT BUILDING PROPERTY ASSESSMENT DETAILS']) &&
                      (
                        <>
                          <td className="font-weight-bold cms-bg-color-primary-light cms-text-primary">Appraised Value</td>
                          <td className="font-weight-bold cms-bg-color-primary-light cms-text-primary">Depreciation</td>
                          <td className="font-weight-bold cms-bg-color-primary-light cms-text-primary">Market Value</td>
                        </>
                      )}
                    <td className="font-weight-bold cms-bg-color-primary-light cms-text-primary">Assessment Level</td>
                    <td className="font-weight-bold cms-bg-color-primary-light cms-text-primary">Assessed Value</td>
                    <td className="font-weight-bold cms-bg-color-primary-light cms-text-primary">Taxability</td>
                    <td className="font-weight-bold cms-bg-color-primary-light cms-text-primary">Tax Exempt Code</td>
                    <td className="font-weight-bold cms-bg-color-primary-light cms-text-primary">Exemption Reason</td>
                  </tr>
                </thead>
                <tbody>
                  {historyPropertyAssessmentList &&
                    historyPropertyAssessmentList.length <= 0 && (
                      <tr className="text-center">
                        <td className="history-color" colSpan="7">No data</td>
                      </tr>
                    )}
                  {historyPropertyAssessmentList &&
                    historyPropertyAssessmentList.map(item => (
                      <tr key={item.id}>
                        <td className="fixed-col history-color">{formatNumberWithCommas(_.get(item, 'attributes.actual_use'))}</td>
                        <td className="history-color">{formatNumberWithCommas(_.get(item, 'attributes.area'))}</td>
                        {Acl(permissions, ['E2E RPT BUILDING PROPERTY ASSESSMENT DETAILS']) &&
                          (
                            <>
                              <td className="history-color">{formatNumberWithCommas(_.get(item, 'attributes.appraised_value'))}</td>
                              <td className="history-color">{formatNumberWithCommas(_.get(item, 'attributes.depreciation'))}</td>
                              <td className="history-color">{formatNumberWithCommas(_.get(item, 'attributes.market_value'))}</td>
                            </>
                          )}
                        <td className="history-color">{formatNumberWithCommas(_.get(item, 'attributes.assessment_level'))}</td>
                        <td className="history-color">{formatNumberWithCommas(_.get(item, 'attributes.assessed_value'))}</td>
                        <td className="text-center">
                          <input
                            name="taxability"
                            type="checkbox"
                            checked={_.get(item, 'attributes.taxability')}
                            disabled
                            onChange={(e) =>
                              handleChange(e, applicationId, item)
                            }
                          />
                        </td>
                        <td>
                          <span style={{ color: '#65676b' }}>
                            {_.get(item, 'attributes.tax_exempt_code')}
                          </span>
                        </td>
                        {_.get(item, 'attributes.taxability') === 0 && (
                          <td className="text-center">
                            <button
                              type="button"
                              onClick={handleView(
                                _.get(item, 'attributes.reason')
                              )}
                              className="btn-blank button-eye"
                            >
                              <i className="far fa-eye icon-view" />
                            </button>
                          </td>
                        )}
                      </tr>
                    ))}
                  <tr>
                    <td className="fixed-col history-color"><span className="font-weight-bold">Total</span></td>
                    <td className="history-color bg-white"><span className="font-weight-bold">{historyTotalArea || '--'}</span></td>
                    {Acl(permissions, ['E2E RPT BUILDING PROPERTY ASSESSMENT DETAILS']) &&
                      (
                        <>
                          <td className="history-color bg-white"><span className="font-weight-bold">{historyTotalAppraisedValue || '--'}</span></td>
                          <td className="history-color bg-white"><span className="font-weight-bold">{historyTotalDepreciation || '--'}</span></td>
                          <td className="history-color bg-white"><span className="font-weight-bold">{historyTotalMarketValue || '--'}</span></td>
                        </>
                      )}
                    <td className="history-color bg-white"><span className="font-weight-bold">{historyTotalAssessmentLevel || '--'}</span></td>
                    <td className="history-color bg-white"><span className="font-weight-bold">{historyTotalAssessedValue}</span></td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </>
      )}
    </div>

  );
}

PropertyAssessmentTab.defaultProps = {
  applicationId: '',
  historyInfo: {}
};

PropertyAssessmentTab.propTypes = {
  applicationId: PropTypes.string,
  permissions: PropTypes.instanceOf(Array).isRequired,
  getPropertyAssessmentLogs: PropTypes.instanceOf(Function).isRequired,
  isLoadingHistoryPropertyAssessment: PropTypes.bool.isRequired,
  historyPropertyAssessmentList: PropTypes.instanceOf(Array).isRequired,
  historyTotalAppraisedValue: PropTypes.string.isRequired,
  historyTotalAssessmentLevel: PropTypes.string.isRequired,
  historyTotalAssessedValue: PropTypes.string.isRequired,
  historyTotalDepreciation: PropTypes.string.isRequired,
  historyTotalMarketValue: PropTypes.string.isRequired,
  historyTotalArea: PropTypes.string.isRequired,
  historyInfo: PropTypes.instanceOf(Object),
};

const mapStateToProps = ({ api }) => ({
  historyPropertyAssessmentList: _.get(api, `${c.GET_PROPERTY_ASSESSMENT_LOGS}.list`) || [],
  isLoadingHistoryPropertyAssessment: _.get(api, 'loading', []).indexOf(c.GET_PROPERTY_ASSESSMENT_LOGS) > -1,
  historyTotalAppraisedValue: _.get(api, `${c.GET_PROPERTY_ASSESSMENT_LOGS}.res.total_appraised_value`) || '--',
  historyTotalArea: _.get(api, `${c.GET_PROPERTY_ASSESSMENT_LOGS}.res.total_area`) || '--',
  historyTotalAssessedValue: _.get(api, `${c.GET_PROPERTY_ASSESSMENT_LOGS}.res.total_assessed_value`) || '--',
  historyTotalAssessmentLevel: _.get(api, `${c.GET_PROPERTY_ASSESSMENT_LOGS}.res.total_assessment_level`) || '--',
  historyTotalDepreciation: _.get(api, `${c.GET_PROPERTY_ASSESSMENT_LOGS}.res.total_depreciation`) || '--',
  historyTotalMarketValue: _.get(api, `${c.GET_PROPERTY_ASSESSMENT_LOGS}.res.total_market_value`) || '--',
  permissions: getJson('permissions'),
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, actions)]);

export default enhance(PropertyAssessmentTab);
